import React from "react";
import { Link } from "react-router-dom";
import logoImg from "../../Assests/images/w_logo.png";

function FooterV1() {
  return (
    <footer className="v1-footer">
      <div className="v1-footer-container">
        {/* Top Section */}
        <div className="v1-footer-top-section">
          {/* Left Brand Column */}
          <div className="v1-footer-brand-box">
            <Link to="/-v1" className="v1-footer-logo-link" aria-label="Weyfarin Home">
              <img src={logoImg} alt="Weyfarin" className="v1-footer-logo-img" />
            </Link>

            <p className="v1-footer-tagline">
              Discover unique experiences led by local experts around the world.
            </p>

            <div className="v1-footer-social-row">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="v1-footer-social-circle"
                aria-label="Instagram"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a>

              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                className="v1-footer-social-circle"
                aria-label="Twitter"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
                </svg>
              </a>

              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="v1-footer-social-circle"
                aria-label="Facebook"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Right 4 Columns Grid */}
          <div className="v1-footer-links-grid">
            {/* Column 1: Explore */}
            <div className="v1-footer-col">
              <h4 className="v1-footer-heading">Explore</h4>
              <ul className="v1-footer-list">
                <li>
                  <Link to="/experiences" className="v1-footer-item-link">
                    Popular Experiences
                  </Link>
                </li>
                <li>
                  <Link to="/experiences" className="v1-footer-item-link">
                    Top Destinations
                  </Link>
                </li>
                <li>
                  <Link to="/experiences" className="v1-footer-item-link">
                    Solo Travel
                  </Link>
                </li>
                <li>
                  <Link to="/experiences" className="v1-footer-item-link">
                    Adventure
                  </Link>
                </li>
                <li>
                  <Link to="/experiences" className="v1-footer-item-link">
                    Cultural
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 2: Hosting */}
            <div className="v1-footer-col">
              <h4 className="v1-footer-heading">Hosting</h4>
              <ul className="v1-footer-list">
                <li>
                  <Link to="/host-add-profiles" className="v1-footer-item-link">
                    Become a Host
                  </Link>
                </li>
                <li>
                  <Link to="/help-and-faq" className="v1-footer-item-link">
                    Host Resources
                  </Link>
                </li>
                <li>
                  <Link to="/help-and-faq" className="v1-footer-item-link">
                    Community Forum
                  </Link>
                </li>
                <li>
                  <Link to="/help-and-faq" className="v1-footer-item-link">
                    Host Insurance
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Support */}
            <div className="v1-footer-col">
              <h4 className="v1-footer-heading">Support</h4>
              <ul className="v1-footer-list">
                <li>
                  <Link to="/help-and-faq" className="v1-footer-item-link">
                    Help Center
                  </Link>
                </li>
                <li>
                  <Link to="/help-and-faq" className="v1-footer-item-link">
                    Safety
                  </Link>
                </li>
                <li>
                  <Link to="/cancellation" className="v1-footer-item-link">
                    Cancellation Policy
                  </Link>
                </li>
                <li>
                  <Link to="/help-and-faq" className="v1-footer-item-link">
                    Accessibility
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 4: Company */}
            <div className="v1-footer-col">
              <h4 className="v1-footer-heading">Company</h4>
              <ul className="v1-footer-list">
                <li>
                  <Link to="/about" className="v1-footer-item-link">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/job-opening" className="v1-footer-item-link">
                    Careers
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="v1-footer-item-link">
                    Press
                  </Link>
                </li>
                <li>
                  <Link to="/blogs" className="v1-footer-item-link">
                    Blog
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="v1-footer-bottom-bar">
          <p className="v1-footer-copyright">
            © 2026 Weyfarin, Inc. All rights reserved.
          </p>

          <div className="v1-footer-legal-links">
            <Link to="/privacy-policy" className="v1-footer-legal-link">
              Privacy
            </Link>
            <Link to="/term-service" className="v1-footer-legal-link">
              Terms
            </Link>
            <Link to="/site-map" className="v1-footer-legal-link">
              Sitemap
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterV1;
